(()=>{
  let requestController=null;
  let desktopFilterTimer=null;
  let lastFilterTrigger=null;

  const PREVIEW_PARAMS=['preview_theme_id','_ab','_fd','_sc'];
  const section=()=>document.querySelector('[data-collection-section]');
  const filterDrawer=()=>document.querySelector('[data-filter-drawer]');

  function preserveThemeContext(url){
    const current=new URL(window.location.href);
    PREVIEW_PARAMS.forEach((key)=>{
      if(!url.searchParams.has(key)&&current.searchParams.has(key)){
        url.searchParams.set(key,current.searchParams.get(key));
      }
    });
    return url;
  }

  function setBodyLock(locked){
    document.documentElement.style.overflow=locked?'hidden':'';
    document.body.style.overflow=locked?'hidden':'';
  }

  function openFilters(button){
    const drawer=filterDrawer();
    if(!drawer)return;
    lastFilterTrigger=button||document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    button?.setAttribute('aria-expanded','true');
    setBodyLock(true);
    requestAnimationFrame(()=>drawer.querySelector('.collection-filter-drawer__close')?.focus());
  }

  function closeFilters({restoreFocus=true}={}){
    const drawer=filterDrawer();
    if(!drawer)return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.querySelector('[data-filter-drawer-open]')?.setAttribute('aria-expanded','false');
    setBodyLock(false);
    if(restoreFocus&&lastFilterTrigger&&document.contains(lastFilterTrigger))lastFilterTrigger.focus();
  }

  function formUrl(form){
    const url=preserveThemeContext(new URL(form.action,window.location.origin));
    const data=new FormData(form);
    data.forEach((value,key)=>{
      const normalized=String(value).trim();
      if(normalized!=='')url.searchParams.append(key,normalized);
    });
    return url;
  }

  function loading(active){
    const current=section();
    if(!current)return;
    current.classList.toggle('is-loading',active);
    current.setAttribute('aria-busy',active?'true':'false');
  }

  function promoteDescriptionBanner(){
    const current=section();
    const seo=current?.querySelector('.collection-page__seo-content');
    if(!current||!seo)return;

    const image=seo.querySelector('img');
    if(!image)return;

    const source=image.closest('a')||image;
    const hasDedicatedBanner=Boolean(document.querySelector('.collection-banner'));

    if(!hasDedicatedBanner&&!document.querySelector('[data-description-banner]')){
      const banner=document.createElement('section');
      banner.className='collection-description-banner';
      banner.dataset.descriptionBanner='';
      banner.setAttribute('aria-label',image.alt||current.dataset.promotionLabel||'Collection promotion');

      const inner=document.createElement('div');
      inner.className='page-width collection-description-banner__inner';
      const media=document.createElement('div');
      media.className='collection-description-banner__media';
      const clone=source.cloneNode(true);
      const cloneImage=clone.matches?.('img')?clone:clone.querySelector?.('img');
      if(cloneImage){
        cloneImage.removeAttribute('width');
        cloneImage.removeAttribute('height');
        cloneImage.loading='eager';
        cloneImage.fetchPriority='high';
      }
      media.appendChild(clone);
      inner.appendChild(media);
      banner.appendChild(inner);
      current.before(banner);
    }

    source.remove();
    if(!seo.querySelector('p,ul,ol,h3,h4,h5,h6,blockquote')){
      seo.remove();
    }
  }

  function toggleFilterValues(button){
    const listId=button.getAttribute('aria-controls');
    const list=listId?document.getElementById(listId):null;
    if(!list)return;
    const expanded=button.getAttribute('aria-expanded')==='true';
    list.querySelectorAll('[data-filter-extra]').forEach((item)=>{
      if(expanded&&!item.querySelector('input:checked'))item.hidden=true;
      else item.hidden=false;
    });
    button.setAttribute('aria-expanded',expanded?'false':'true');
    const label=button.querySelector('[data-filter-toggle-label]');
    if(label)label.textContent=expanded?(current?.dataset.showMore||'Show more'):(current?.dataset.showLess||'Show less');
  }

  function hasExpectedProductCardMarkup(replacement){
    const grid=replacement.querySelector('.collection-product-grid');
    if(!grid||grid.children.length===0)return true;
    return Boolean(grid.querySelector('.product-card__media img'));
  }

  async function renderCollection(target,{push=true,scroll=false}={}){
    const current=section();
    if(!current)return;
    const sectionId=current.dataset.sectionId;
    const publicUrl=preserveThemeContext(new URL(target,window.location.origin));
    const fetchUrl=new URL(publicUrl.href);
    fetchUrl.searchParams.set('sections',sectionId);

    requestController?.abort();
    requestController=new AbortController();
    loading(true);

    try{
      const response=await fetch(fetchUrl.href,{headers:{Accept:'application/json'},signal:requestController.signal,credentials:'same-origin'});
      if(!response.ok)throw new Error('Unable to refresh collection');
      const data=await response.json();
      const html=data?.[sectionId];
      if(!html)throw new Error('Collection section was not returned');

      const parsed=new DOMParser().parseFromString(html,'text/html');
      const replacement=parsed.querySelector('[data-collection-section]');
      if(!replacement)throw new Error('Collection section markup was not found');
      if(!hasExpectedProductCardMarkup(replacement))throw new Error('Collection response came from an incompatible theme');

      current.replaceWith(replacement);
      setBodyLock(false);
      promoteDescriptionBanner();
      if(push)window.history.pushState({},'',publicUrl.href);
      if(scroll){
        const toolbar=replacement.querySelector('.collection-toolbar');
        const top=(toolbar?.getBoundingClientRect().top||replacement.getBoundingClientRect().top)+window.scrollY-110;
        window.scrollTo({top:Math.max(0,top),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
    }catch(error){
      if(error.name==='AbortError')return;
      window.location.assign(publicUrl.href);
    }finally{
      loading(false);
      requestController=null;
    }
  }

  function submitCollectionForm(form,{scroll=false}={}){
    renderCollection(formUrl(form),{push:true,scroll});
  }

  function focusables(panel){
    return [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((el)=>!el.hasAttribute('hidden'));
  }

  document.addEventListener('submit',(event)=>{
    const filterForm=event.target.closest('[data-collection-filter-form]');
    if(filterForm){
      event.preventDefault();
      submitCollectionForm(filterForm,{scroll:true});
      return;
    }
    const sortForm=event.target.closest('[data-collection-sort-form]');
    if(sortForm){
      event.preventDefault();
      submitCollectionForm(sortForm,{scroll:true});
    }
  });

  document.addEventListener('change',(event)=>{
    if(event.target.matches('[data-sort-select]')){
      event.target.form?.requestSubmit();
      return;
    }

    const desktopForm=event.target.closest('.collection-sidebar [data-collection-filter-form]');
    if(desktopForm&&event.target.matches('input[type="checkbox"]')){
      window.clearTimeout(desktopFilterTimer);
      desktopFilterTimer=window.setTimeout(()=>submitCollectionForm(desktopForm,{scroll:false}),220);
    }
  });

  document.addEventListener('click',(event)=>{
    const filterToggle=event.target.closest('[data-filter-values-toggle]');
    if(filterToggle){event.preventDefault();toggleFilterValues(filterToggle);return;}

    const opener=event.target.closest('[data-filter-drawer-open]');
    if(opener){event.preventDefault();openFilters(opener);return;}

    const closer=event.target.closest('[data-filter-drawer-close]');
    if(closer){event.preventDefault();closeFilters();return;}

    const link=event.target.closest('[data-collection-link]');
    if(link&&link.href){
      const url=new URL(link.href,window.location.origin);
      if(url.origin===window.location.origin){
        event.preventDefault();
        renderCollection(url,{push:true,scroll:true});
      }
    }
  });

  document.addEventListener('keydown',(event)=>{
    const drawer=filterDrawer();
    if(!drawer?.classList.contains('is-open'))return;
    if(event.key==='Escape'){event.preventDefault();closeFilters();return;}
    if(event.key!=='Tab')return;
    const panel=drawer.querySelector('.collection-filter-drawer__panel');
    const items=panel?focusables(panel):[];
    if(!items.length)return;
    const first=items[0];
    const last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });

  window.addEventListener('popstate',()=>renderCollection(window.location.href,{push:false,scroll:false}));

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',promoteDescriptionBanner,{once:true});
  else promoteDescriptionBanner();
})();